import React from 'react';
import PropTypes from 'prop-types';
import { Wrapper, LinkButton, Links, LinkItem } from './SectionSidebarStyles';
import { SectionTitle } from '../SectionTitleStyle';

const SectionSidebar = ({ links, onLinkClick, sectionTitle }) => (
  <Wrapper>
    <SectionTitle>{sectionTitle}</SectionTitle>
    <Links>
      {links.map(({ label, isActive, controller, params }) => (
        <LinkItem key={label}>
          <LinkButton isActive={isActive} onClick={() => onLinkClick(controller, params)}>
            {label}
          </LinkButton>
        </LinkItem>
      ))}
    </Links>
  </Wrapper>
);

SectionSidebar.propTypes = {
  links: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  sectionTitle: PropTypes.string.isRequired,
  onLinkClick: PropTypes.func.isRequired,
};

export default SectionSidebar;
